import { render } from "./PartHistoryTable.vue?vue&type=template&id=4fcdba82&scoped=true"
import script from "./PartHistoryTable.vue?vue&type=script&lang=js"
export * from "./PartHistoryTable.vue?vue&type=script&lang=js"

import "./PartHistoryTable.vue?vue&type=style&index=0&id=4fcdba82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fcdba82"]])

export default __exports__